import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { createSelector } from 'reselect';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import messages from './messages';
import style from './order-templates.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

const handlePackingSlipClick = createSelector(
  (onPackingSlipSelected) => onPackingSlipSelected,
  (_, packingSlip) => packingSlip,
  (onPackingSlipSelected, packingSlip) => () => onPackingSlipSelected(packingSlip),
);

const PackingSlipSelector = ({ onPackingSlipSelected, packingSlips = emptyArray, selected }) => {
  return (
    <div className={classnames(style['select-container'], 'select-container')}>
      <label className={style['select-label']}>
        <FormattedMessage {...messages.packingSlipLabel} />
      </label>
      <DropdownMenu className={style['select-dropdown-menu']} dropdownMenuShouldHaveWidthOfButton>
        <DropdownMenuToggler theme='white'>
          {selected && selected.name}
          {!selected && <FormattedMessage {...messages.packingSlipDefault} />}
        </DropdownMenuToggler>
        {packingSlips.map((packingSlip) => (
          <DropdownMenuItem
            key={packingSlip.name}
            onClick={handlePackingSlipClick(onPackingSlipSelected, packingSlip)}
            selected={selected && packingSlip.name === selected.name}
          >
            {packingSlip.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    </div>
  );
};

PackingSlipSelector.propTypes = {
  selected: PropTypes.object.isRequired,
  onPackingSlipSelected: PropTypes.func.isRequired,
  packingSlips: PropTypes.array,
};

export default PackingSlipSelector;
